import React from 'react';
import { TableStatePreserver } from 'views/issueTable/tableView/TableState';

export const TableStateContext = React.createContext<TableStatePreserver>(
  null!
);
